import { Wording } from '@/types';

export const COOKING_WORDING_SI: Wording = {
  components_header_media_content: 'Kuharski videoposnetki',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Recepti',
  components_header_text2: 'Blog',
  components_header_members: 'Člani',
  hero_text: 'Kuhajte s strastjo, jejte z veseljem',
  hero_button_text: 'Začnite kuhati še danes',
  components_ressources_section_title: 'VIRI',
  components_ressources_subheader_text: 'Vsi viri, ki jih potrebujete za učenje, kuhanje in ustvarjanje boljše hrane',
  components_ressources_span_text: 'Odkrijte bogato zbirko video receptov, podrobnih kuharskih vodnikov in strokovnih vpogledov v kombiniranje okusov, predstavitev hrane in kulinarično ustvarjalnost.',
  components_ressources_card_1_title: 'Navdih za kuhanje',
  components_ressources_card_1_text: 'Poiščite navdih v ustvarjalnih receptih in kuharskih videoposnetkih.',
  components_ressources_card_2_title: 'Kuharsko znanje',
  components_ressources_card_2_text: 'Naučite se bistvenih tehnik kuhanja, kombinacij okusov in osnov kombiniranja jedi s pomočjo jasnih in praktičnih vodnikov.',
  components_ressources_link: 'Oglejte si videoposnetke',
  components_notes_and_google_title_1: 'Kuharsko izobraževanje',
  components_notes_and_google_title_2: 'Vsakodnevno kuhanje',
  components_notes_and_google_title_3: 'Dosledne kuharske spretnosti',
  components_review_google_text: 'Ocene na Googlu',
  media_content_section_title: 'Kuharski videoposnetki',
  media_content_section_subheader_text: 'Raziščite recepte in videoposnetke kuhanja po korakih.',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Več videoposnetkov',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Vodniki in članki',
  text2_section_button_more: 'Več člankov',
  components_text1_section_title: 'RECEPTI',
  components_text1_subheader_text: 'Okusni recepti za vsakodnevno kuhanje',
  components_text1_span_text: 'Odkrijte preproste recepte za vsakodnevne obroke, jasne korake in odlične rezultate.',
  components_text1_card_1_title: 'Začnite svoj dan pravilno',
  components_text1_card_1_text: 'Preprosti in okusni recepti za lahkoten in okusen začetek dneva.',
  components_text1_card_3_title: 'Ideje za okusno kosilo',
  components_text1_card_3_text: 'Okusni recepti za kosilo, ki so enostavni za pripravo in polni okusa.',
  components_text1_card_2_title: 'Recepti za tolažilno večerjo',
  components_text1_card_2_text: 'Topli, nasitni recepti za večerjo, idealni za sproščene večere doma.',
  components_text1_link: 'Oglejte si vse recepte',
  components_footer_text: 'Naučite se bolje kuhati, ustvarite boljšo hrano: Vaša kuhinja, vaše potovanje.',
  components_footer_info: 'Informacije',
  components_footer_registration_number: 'Registrska številka',
  components_footer_legal: 'Pravno',
  components_footer_terms: 'Pogoji poslovanja',
  components_footer_privacy: 'Pravilnik o zasebnosti',
  button_load_more: 'Naloži več',
  page_media_1_content_hero_text: 'Odkrijte preproste kuharske videoposnetke za vsak okus',
  page_text1_hero_text: 'Recepti',
  page_text1_section_title: 'Nasveti za kuhanje',
  page_text1_subheader_text: 'Recepti',
  page_text2_hero_text: 'Naš blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Vodniki in članki',
  enter_email_title: 'Za nadaljevanje vnesite svoj e-poštni naslov',
  enter_email_placeholder_email: 'E-pošta',
  enter_email_button_enter: 'Vnesite',
  components_login_success_text: 'Prijava uspešna!',
  components_card_link_media_content: 'Oglejte si zdaj',
  components_card_link_text1_content: 'Ogled recepta',
  components_card_link_text2_content: 'Ogled članka',
};